import React from "react";
import OpcionDefecto from "../../../../../Common/Components/OpcionDefecto";
import CheckDefecto from "../../../../../Common/Components/CheckDefecto";

const GruposAfinidadVisa = ({ data, selectCheckBox, selectCombo }) => {
    const { GET_GRUPO_AFINIDAD_ADMINISTRADORA } = data;
    const arrayAux = GET_GRUPO_AFINIDAD_ADMINISTRADORA.filter(d => d.Checked);
    return (
        <div className="row top-separator-xxs">
            <div className="col-xs-12 top-separator-xxs">
                <label className="label-primary">{"Grupos de Afinidad"}</label>
            </div>
            <div className="col-xs-12">
                <CheckDefecto
                    nombre={"Asociar a Grupo de Afinidad"}
                    check={data.AsociaGrupoAfinidad}
                    referencia={"ASOGRUA"}
                    selectCheckBox={(event) => selectCheckBox("AsociaGrupoAfinidad", event.target.checked)}
                />
            </div>
            {data.AsociaGrupoAfinidad && <div className="col-xs-12 left-separator-xs top-separator-xxs">
                {GET_GRUPO_AFINIDAD_ADMINISTRADORA.map( ( item ) => {
                    const referencia = `GGAA-${item.Id}`;

                    return (
                        (item.Activo || item.noDisponible) && <CheckDefecto
                            key={item.Id}
                            nombre={item.Descripcion}
                            check={item.Checked}
                            activo={item.Activo}
                            referencia={referencia}
                            selectCheckBox={() => {
                                if ( data.AsociaGrupoAfinidad ) {
                                    selectCheckBox( "GET_GRUPO_AFINIDAD_ADMINISTRADORA", item.Id );
                                }
                            }}
                        />
                    )
                } )}
            </div>}
            <div className="col-xs-12">
                {data.AsociaGrupoAfinidad && <OpcionDefecto
                    infoData={arrayAux}
                    referencia={"GrupoAfinidadDefaultId"}
                    valorCombo={data.GrupoAfinidadDefaultId}
                    valorChecked={data.GrupoAfinidadDefaultInterfaz}
                    selecciono={arrayAux.length}
                    selectCombo={(value) => selectCombo("GrupoAfinidadDefaultId", value)}
                    selectCheckBox={(value) => selectCheckBox("GrupoAfinidadDefaultInterfaz", value)}
                />}
                
                {(data.AsociaGrupoAfinidad && !data.ERROR_PRODUCT["seleccionoGrupoAfinidad"] && arrayAux.length==0)
                    && <label className="error">{"Debe seleccionar al menos un grupo de afinidad."}</label>}
            </div>
        </div>
    );
}

export default GruposAfinidadVisa;